const BASE = process.env.REACT_APP_BASENAME ?? "";
const assetPath = (path: string) => `${BASE}${path}`;
export default assetPath;
